import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.test.js";
import { assert } from "@/common/assert";
import { FHTChatId } from "./FHTChatId"; //判断clientId是不是属于注册用户的

export function isUserClientId(clientId) {
  if (!clientId) throw new Error("empty clientId");
  var tokens = clientId.split("_");
  return $.isNumeric(tokens[0]) && !!tokens[1] && tokens[1].length === 16;
}
export function getUserIdFromClientId(clientId) {
  if (!isUserClientId(clientId)) {
    throw new Error(clientId + " doesn't belong to a user");
  }

  return parseInt(clientId.split("_")[0], 10);
}
export function isValidConvId(convId) {
  assert(convId, "convId falsy");
  return /[0-9a-f]{24}/.test(convId);
}
/**
 * @deprecated  use FHTChatId.parse method instead
 */

export function tryParseChatIdFromRawChatId(encodedChatId) {
  try {
    return FHTChatId.decode(encodedChatId);
  } catch (_a) {
    return;
  }
}